const medicineBazarEn = {
  search: {
    placeholders: [
      'Type a medicine name...',
      'Type a generic name...',
      'Type a company name...',
      'Type a brand name...',
      'Type a store name...'
    ]
  },
  sidebar: {
    categoriesTitle: 'Categories',
    storesTitle: 'Stores'
  },
  upload: {
    title: 'Upload Prescription',
    subtitle: 'Upload your doctor’s prescription and order medicines easily',
    uploadedPrefix: '✓ File uploaded:',
    chooseFile: 'Choose File',
    replaceFile: 'Upload New File'
  },
  store: {
    serviceAreaLabel: 'Service Area',
    nationwide: 'Nationwide',
    medicineCountLabel: 'Medicines',
    close: 'Close',
    productsOfSuffix: 'Medicines',
    descriptionPrefix: 'Below are all available medicines from',
    descriptionSuffix: 'pharmacy. You can filter by category.'
  },
  card: {
    addToCart: 'Add to Bag'
  },
  empty: {
    title: 'No medicines found',
    subtitle: 'Please choose another category or pharmacy'
  },
  prescriptionFlow: {
    successTitle: 'Prescription uploaded successfully!',
    instruction: 'Please fill the following details to place your medicine order',
    step1: {
      title: 'Choose a Pharmacy',
      subtitle: 'Which pharmacy would you like to buy from?',
      next: 'Next'
    },
    step2: {
      title: 'Select Course Duration',
      subtitle: 'For how many days do you want medicines?',
      fullCourse: 'Full Course',
      fiveDays: 'For 5 days',
      tenDays: 'For 10 days',
      customDays: 'Custom days',
      customDaysLabel: 'How many days?',
      customDaysPlaceholder: 'e.g., 15',
      back: 'Back',
      next: 'Next'
    },
    step3: {
      title: 'Confirm Order',
      summaryTitle: 'Your order summary:',
      pharmacyLabel: 'Pharmacy',
      durationLabel: 'Course Duration',
      prescriptionLabel: 'Prescription',
      back: 'Back',
      confirm: 'Confirm Order'
    },
    snackbar: {
      successTitle: '🎉 Order submitted successfully!',
      message: 'Your selected pharmacy will contact you soon with price and details.'
    }
  }
};

export default medicineBazarEn;


